import {
    IUser,
} from "./types";
import {createAsyncAction} from "typesafe-actions";

export const fetchUserByIdAsyncActions = createAsyncAction(
    'FETCH_USER_BY_ID_REQUEST',
    'FETCH_USER_BY_ID_SUCCESS',
    'FETCH_USER_BY_ID_FAILURE'
)<{ id: string }, { user: IUser }, { error: Error }>();


export const loginAsyncActions = createAsyncAction(
    'LOGIN_REQUEST',
    'LOGIN_SUCCESS',
    'LOGIN_FAILURE'
)<{}, { user: IUser }, { error: Error }>();


export const logoutAsyncActions = createAsyncAction(
    'LOGOUT_REQUEST',
    'LOGOUT_SUCCESS',
    'LOGOUT_FAILURE'
)<{}, {}, { error: Error }>();
